import { Action } from '@ngrx/store';

import { ErrCode } from '../shared/models';
import { cAccountInfo } from '../shared/models/api/chargbeeprofile-api.model';

export const CHARGEBEE_GET = '[Chargebee] Get';
export const CHARGEBEE_FAILURE = '[Chargebee] failure';
export const CHARGEBEE_SUCCESS = '[Chargebee] success';

export class ChargebeeSuccessAction implements Action {
    readonly type = CHARGEBEE_SUCCESS;
    constructor(public payload: {cprofile: cAccountInfo}) {}
}

export class ChargebeeFailureAction implements Action {
    readonly type = CHARGEBEE_FAILURE;
    constructor(public payload: ErrCode) {}
}

export class ChargebeeGetAction implements Action {
    readonly type = CHARGEBEE_GET;
    constructor() {}
}
export type All =
    | ChargebeeGetAction
    | ChargebeeFailureAction
    | ChargebeeSuccessAction